<template>
  <div class="flex flex-col items-center pt-16">
    <div class="w-[94%] md:w-[75%] 2xl:w-[60%]">
      <h2 class="text-3xl font-semibold text-mainColor text-center">{{ section.name }}</h2>
      <p class="pt-2 text-center md:px-12 pb-5">{{ section.description }}</p>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        <div v-for="item in items" :key="item.id">
          <img class="w-full h-full object-cover" :src="item.icon" alt="" />
        </div>
      </div>
      <div class="pt-3">
        <p>{{ section.subDescription }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "@/firebaseConfig";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
export default {
  name: "WhoWeAre",
  data() {
    return {
      items: [],
      mainDocId: null,
      section: {
        name: "",
        description: "",
      },
    };
  },
  mounted() {
    this.fetchMainDoc();
  },
  methods: {
    async fetchMainDoc() {
      const snapshot = await getDocs(collection(db, "whoWeAre"));
      if (!snapshot.empty) {
        const docSnap = snapshot.docs[0];
        this.mainDocId = docSnap.id;
        this.section = {
          name: docSnap.data().name,
          description: docSnap.data().description,
          subDescription: docSnap.data().subDescription,
        };
        this.fetchItems();
      }
    },
    async fetchItems() {
      const q = query(
        collection(db, "whoWeAre", this.mainDocId, "items"),
        orderBy("orderNumber", "asc")
      );
      const snapshot = await getDocs(q);
      this.items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    },
  },
};
</script>
